import {SyncDevice} from "../../domain/sync/SyncDevice";
import AppDB from "../persistence/indexed-db";

const registerNewDevice = (syncDevice: SyncDevice) => {
    AppDB.syncable.connect('webrtc', syncDevice.uuid).catch(e => console.error(e))
}

export default registerNewDevice;